<template>
  <v-app>
    <!-- New Version Available Snackbar -->
    <v-snackbar v-model="showNewVersionAlert" :timeout="-1" bottom left color="primary">
      <v-icon left>mdi-update</v-icon>
      發現新版本，請刷新頁面以獲取最新功能
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="reloadPage"> 刷新頁面 </v-btn>
        <v-btn icon small v-bind="attrs" @click="showNewVersionAlert = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-alert class="popAlert" v-if="displayAlert" :type="alertType" :color="color">
      <div style="text-align: center">{{ alertMessage }}</div>
      <template v-slot:close>
        <v-icon @click="closeAlert"> mdi-close</v-icon>
      </template>
    </v-alert>
    <v-navigation-drawer
      v-if="!hideDrawer"
      :mini-variant="mini"
      touchless
      permanent
      v-model="drawer"
      app
    >
      <drawer />
    </v-navigation-drawer>
    <CustomDialog ref="confirm"></CustomDialog>
    <v-app-bar app flat class="whatsappGrey" dense>
      <!--      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />-->
      <img src="@/assets/indexLogo@180h.png" style="width: 30px; height: 30px; padding: 2.5px" />
      <!--      <v-toolbar-title>Title</v-toolbar-title> -->
      <!--      <v-menu bottom right>-->
      <!--        <template v-slot:activator="{ on, attrs }">-->
      <!--          <v-btn icon color="inherit" v-bind="attrs" v-on="on">-->
      <!--            <v-icon>mdi-dots-vertical</v-icon>-->
      <!--          </v-btn>-->
      <!--        </template>-->

      <!--        <v-list>-->
      <!--          <v-list-item v-for="(item, i) in items" :key="i">-->
      <!--            <v-list-item-title>{{ item.title }}</v-list-item-title>-->
      <!--          </v-list-item>-->
      <!--        </v-list>-->
      <!--      </v-menu>-->
      <v-spacer />
      <div class="d-flex align-center">
        <small v-if="debug">DEBUG MODE </small>
        <small @click="triggerDebugMode">{{ buildVersion }}</small>
      </div>
      <v-spacer />
      <div class="pr-sm-3 d-flex align-center">
        <h3>
          {{ profile && profile.name }} (<span style="text-transform: capitalize">{{ role }}</span
          >)
        </h3>
      </div>
      <a @click="myProfile" class="mr-sm-8">
        <v-icon style="font-size: 30px"> mdi-account</v-icon>
      </a>
      <a @click="ssoLogout" v-if="isLoggedIn">
        <v-icon style="font-size: 30px"> mdi-logout-variant</v-icon>
      </a>
      <a v-else>
        <v-icon style="font-size: 30px"> mdi-login-variant</v-icon>
      </a>
    </v-app-bar>
    <v-main>
      <BlockedView v-if="loginBlocked" class="text-center">
        <div style="background-color: red; padding: 50px; border-radius: 100px">
          <h2 style="color: white; text-align: center; margin-bottom: 20px">
            Your working has been blocked
            <br />
            Please contact your manager
            <br />
            <template>
              <h3 v-if="loginBlocked.subcode === 'needApproval'">
                Your account need to be approve
              </h3>
              <h3 v-if="loginBlocked.subcode === 'workTimePeriod'">
                Your work time period expired
              </h3>
            </template>
          </h2>
          <v-btn @click="ssoLogout"> Got it</v-btn>
        </div>
      </BlockedView>
      <router-view :key="$route.fullPath" v-else />
    </v-main>
  </v-app>
</template>

<script>
import api from '@/api';
import { ssoLogout } from '@/api/auth/sso';
import BlockedView from '@/components/BlockedView';
import Drawer from '@/layout/partial/drawerNav';
import moment from 'moment';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CustomDialog from '@/components/CustomDialog';
import { startVersionChecker, stopVersionChecker } from '@/services/versionChecker';

const passcode = 'fletrix';

export default {
  components: { BlockedView, Drawer, CustomDialog },
  data() {
    return {
      loginBlockedMessage: '',
      drawer: false,
      clickCount: 0,
      mini: true,
      showNewVersionAlert: false,
    };
  },
  computed: {
    ...mapGetters('alert', ['alertType', 'displayAlert', 'alertMessage', 'color']),
    ...mapGetters('auth', ['profile', 'role', 'isLoggedIn', 'loginBlocked']),
    ...mapGetters(['debug']),
    hideDrawer() {
      return !!this.$route?.meta?.hideDrawer;
    },
    buildVersion() {
      const { time, git } = process.env.BUILD;
      return `ver: ${git.version}-${git.branch} (${moment(time).format('YYYY-MM-DD HH:mm')})`;
    },
  },
  watch: {
    loginBlocked() {
      if (this.loginBlocked) this.dialog = true;
    },
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm;

    // Start version checker
    startVersionChecker(newVersion => {
      console.log('New version available:', newVersion);
      this.showNewVersionAlert = true;
    }, 10000);
  },
  beforeDestroy() {
    stopVersionChecker();
  },
  methods: {
    ...mapActions('alert', ['closeAlert']),
    ...mapActions('auth', ['checkLoginStatus', 'logout']),
    ...mapMutations(['setDebug']),
    myProfile() {
      this.$router.push({ name: 'myProfile' }).catch(() => {});
    },
    async ssoLogout() {
      if (!confirm('Do you confirm to logout?')) return;
      try {
        // Call the backend logout endpoint
        await ssoLogout(api);
      } catch (e) {
        // Even if backend logout fails, we should clear local data
        console.error('Backend logout failed:', e);
      }

      // Clear all local auth data
      await this.logout();

      // Redirect to login page
      await this.$router.push({ name: 'login' });
    },
    triggerDebugMode() {
      this.clickCount += 1;
      if (this.clickCount > 4) {
        const pw = window.prompt('enter passcode');
        if (pw === passcode) this.setDebug(true);
      }
    },
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-dialog--active {
  border-radius: 20px;
}

.v-main {
  height: 100vh;
}

.popAlert {
  position: fixed;
  bottom: 0px;
  z-index: 900;
  width: 60%;
  left: calc((100% - 60%) / 2);
}
</style>
